import { render } from "./cardReissue.vue?vue&type=template&id=1570595e"
import script from "./cardReissue.vue?vue&type=script&lang=js"
export * from "./cardReissue.vue?vue&type=script&lang=js"

import "./cardReissue.vue?vue&type=style&index=0&id=1570595e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__